import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderBulkSelection, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';

export const ServiceOrderSelectionCell = ({ orderId }: { orderId: string }) => {
    const dispatch = useAppDispatch();
    const isSelected = useAppSelector((state) => getServiceOrderBulkSelection(state).includes(orderId));

    const onSelect = () => {
        if (isSelected) {
            dispatch(serviceOrdersSlice.actions.removeFromBulkSelection([orderId]));
        } else {
            dispatch(serviceOrdersSlice.actions.addToBulkSelection([orderId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove order from selection' : 'Add order to selection';

    return (
        <td className="table-checkbox">
            <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
        </td>
    );
};
